/*
* 当前外部订单相关的数据流
* 拉取订单相关外部数据
*/
//引入群组相关接口
import {getOrderInfo,getOrderDataByShare,getLogisticInfo,getLogistic} from './../../api/order';
//引入 axios 批量请求接口
import axios from 'axios';
const state = {};
const mutations = {};
const actions = {
  //拉取订单相关数据
  getOrderInfo({commit},data){
    return new Promise((resolve,reject) =>{
      getOrderInfo(data).then(res=>{
        resolve(res)
      }).catch(err=>{
        reject(err)
      })
    })
  },
  //分享页面根据订单请求外部平台数据
  getOrderDataByShare({commit}, data) {
    return new Promise((resolve, reject) => {
      getOrderDataByShare(data).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  //根据物流单号获取物流信息
  getLogisticInfo({commit}, data) {
    return new Promise((resolve, reject) => {
      getLogisticInfo(data).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  //根据运单号获取物流
  getLogistic({commit}, data) {
    return new Promise((resolve, reject) => {
      getLogistic(data).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/order.js